module.exports = __webpack_public_path__ + "img/expired_seal.422bafe9.png";